document.addEventListener('DOMContentLoaded', () => {
  const $header = document.querySelector('[data-site-header]');
  const $headerActiveOverlay = document.querySelector("[data-header-overlay]");
  const $activeHeaderTriggers = document.querySelectorAll("[data-active-header-trigger]");
  const $closeMobHeaderButton = document.querySelector("[data-close-header]");
  const mobileNavigationContainer = document.querySelector("[data-mobile-navigation-container]");
  const mobileSecondLevelSection = document.querySelector("[data-mobile-second-level-section]");
  const mobileNavPrev = document.querySelector("[data-mobile-nav-previous]");
  const searchInput = document.querySelector("[data-search-input]");
  const searchElement = document.querySelector("[data-active-name='search']");
  const firstLevelLinks = document.querySelectorAll("[data-first-level-link]");
  const subNavElements = document.querySelectorAll("[data-desktop-sub-nav]");
  let isToggling = false;

  const toggleHeaderClass = (method) => {
    const htmlBody = document.querySelector("html, body");
    if (method === "close") {
      $header.classList.remove("active", "full-height", "absolute", "top--0", "left--0");
      htmlBody.classList.remove("overflow--hidden");
      document.querySelector('.header__active').classList.remove('visible');
      document.querySelector('[data-active-name="navigation"]').classList.add('hide');
      subNavElements.forEach(e => e.classList.add('hide'));
    } else {
      $header.classList.add("full-height", "absolute", "top--0", "left--0", "active");
      htmlBody.classList.add("overflow--hidden");
      document.querySelector('.header__active').classList.add('visible');
      document.querySelector('[data-active-name="navigation"]').classList.remove('hide');
    }
  };

  const closeMobHeader = () => {
    toggleHeaderClass("close");
    $activeHeaderTriggers.forEach(item => {
      item.classList.remove("isSelected");
      item.setAttribute("aria-expanded", "false");
    });
    mobileNavigationContainer.classList.remove("shift");
    mobileSecondLevelSection.classList.add("hide");
    mobileNavPrev.classList.add("hide");
    subNavElements.forEach(subNav => subNav.classList.add("hide"));
    searchElement.classList.add("hide");
  };

  const showHeaderTab = ($el) => {
    if (!$header.classList.contains("active")) {
      toggleHeaderClass("open");
    }
    setActiveState($el);
  };

  const setActiveState = ($el) => {
    $activeHeaderTriggers.forEach(item => {
      item.classList.remove("isSelected");
      item.setAttribute("aria-expanded", "false");
    });
    $el.classList.add("isSelected");
    $el.setAttribute("aria-expanded", "true");
    subNavElements.forEach(e => e.classList.add('hide'));
    const key = $el.getAttribute('data-key');
    document.querySelectorAll(`[data-desktop-sub-nav="${key}"]`).forEach(e => e.classList.remove('hide'));
  };

  $activeHeaderTriggers.forEach(trigger => {
    trigger.addEventListener("click", (evt) => {
      evt.preventDefault();
      if (isToggling) return;
      isToggling = true;

      if (trigger.classList.contains("isSelected")) {
        closeMobHeader();
      } else {
        showHeaderTab(trigger);
      }
      setTimeout(() => isToggling = false, 300);
    });

    trigger.addEventListener("keyup", (evt) => {
      if (evt.key === "Enter") trigger.click();
    });
  });

  $headerActiveOverlay.addEventListener("click", closeMobHeader);
  $closeMobHeaderButton.addEventListener("click", closeMobHeader);
  $closeMobHeaderButton.addEventListener("keyup", (evt) => {
    if (evt.key === "Enter") closeMobHeader();
  });

  document.addEventListener("keyup", (e) => {
    if (e.key === "Escape" && $header.classList.contains("active")) closeMobHeader();
  });

  document.querySelector("[data-search-button]").addEventListener("click", (evt) => {
    evt.preventDefault();
    searchElement.classList.remove("hide");
    setTimeout(() => searchInput.focus(), 210);
  });

  firstLevelLinks.forEach((element) => {
    element.addEventListener("click", handleFirstLevelLinkEvent);
    element.addEventListener("keydown", (evt) => {
      if (evt.key === "Enter") handleFirstLevelLinkEvent(evt);
    });
  });

  function handleFirstLevelLinkEvent(evt) {
    const element = evt.currentTarget;
    const key = element.getAttribute("data-key");
    if (evt.type === "click" || (evt.key === "Enter" && evt.type === "keydown")) {
      evt.preventDefault();
      subNavElements.forEach(subNav => subNav.classList.add("hide"));
      document.querySelector(`[data-desktop-sub-nav="${key}"]`).classList.remove("hide");
      mobileNavigationContainer.classList.add("shift");
      mobileNavPrev.classList.toggle("hide", element.getAttribute('data-first-level-single-link') === "true");
      mobileSecondLevelSection.classList.add("hide");
      document.querySelector(`[data-mobile-second-level-section][data-key="${key}"]`).classList.remove("hide");
    }
  }

  mobileNavPrev.addEventListener("click", (evt) => {
    evt.preventDefault();
    closeMobHeader();
  });
});
